import {HttpAxiosRequest} from 'src/http/httpAxiosBase'
import {
  CuentaNotaEstructurada,
  OperacionNotaEstructurada,
  OperacionNotaEstructuradaDetalle, schemaCuentasNotaEstructurada,
  schemaNotaEstructuradaDetalles,
  schemaOperacionNotaEstructurada
} from '../types/types'
import {BaseResponse} from 'src/types'
import {
  OperacionNotaEstructuradaCuentaDetalleUpdate,
  OperacionNotaEstructuradaDetalleInsert,
  OperacionNotaEstructuradaDetalleUpdate,
  OperacionNotaEstructuradaInsert,
  OperacionNotaEstructuradaUpdate, schemaOperacionNotaEstructuradaCuentaDetalleUpdate,
  schemaOperacionNotaEstructuradaDetalleInsert,
  schemaOperacionNotaEstructuradaDetalleUpdate,
  schemaOperacionNotaEstructuradaInsert,
  schemaOperacionNotaEstructuradaUpdate
} from '../types/dto'
import {HttpOperacionInforme} from "../../../api/httpOperacionInforme";
import {SistemaTipo} from "../../../../../types/enum/enum";

export const getEndpoint = (url = '') => `operaciones/nota-estructurada${url}`

export const HttpNotaEstructurada = {
  get: (idOperacion: number): Promise<OperacionNotaEstructurada> => {
    return HttpAxiosRequest.get(getEndpoint(`/${idOperacion}`))
      .then(response => {
        const parsed = schemaOperacionNotaEstructurada.safeParse(response)

        if (!parsed.success) {
          console.error('Error de validación:', parsed.error.issues)

          return Promise.reject(new Error('Error de validación.'))
        }

        return parsed.data
      })
      .catch(error => {
        console.error('Error de red:', error)

        return Promise.reject('Error de red.')
      })
  },

  put: (idOperacion: number, operacion: OperacionNotaEstructuradaUpdate): Promise<BaseResponse> => {
    const parsed = schemaOperacionNotaEstructuradaUpdate.safeParse(operacion)

    if (!parsed.success) {
      console.error('Error de validación:', parsed.error.issues)

      return Promise.reject(new Error('Error de validación.'))
    }

    return HttpAxiosRequest.put(getEndpoint(`/${idOperacion}`), parsed.data) // TODO: parsed.data, no operacion
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(error => {
        console.error('Error de red:', error)

        return Promise.reject('Error de red.')
      })
  },

  post: (operacion: OperacionNotaEstructuradaInsert): Promise<BaseResponse> => {
    const parsed = schemaOperacionNotaEstructuradaInsert.safeParse(operacion)

    if (!parsed.success) {
      console.error('Error de validación:', parsed.error.issues)

      return Promise.reject(new Error('Error de validación.'))
    }

    return HttpAxiosRequest.post(getEndpoint(), parsed.data)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(error => {
        console.error('Error de red:', error)

        return Promise.reject('Error de red.')
      })
  },

  getDetalles: (idOperacion: number): Promise<OperacionNotaEstructuradaDetalle[]> => {
    return HttpAxiosRequest.get(getEndpoint(`/${idOperacion}/detalles`))
      .then(response => {
        const parsed = schemaNotaEstructuradaDetalles.safeParse(response)

        if (!parsed.success) {
          console.error('Error de validación:', parsed.error.issues)

          return Promise.reject(new Error('Error de validación.'))
        }

        return parsed.data
      })
      .catch(error => {
        console.error('Error de red:', error)

        return Promise.reject('Error de red.')
      })
  },

  postDetalle: (idOperacion: number, detalle: OperacionNotaEstructuradaDetalleInsert): Promise<BaseResponse> => {
    const parsed = schemaOperacionNotaEstructuradaDetalleInsert.safeParse(detalle)

    if (!parsed.success) {
      console.error('Error de validación:', parsed.error.issues)

      return Promise.reject(new Error('Error de validación.'))
    }

    return HttpAxiosRequest.post(getEndpoint(`/${idOperacion}/detalles`), parsed.data)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(error => {
        console.error('Error de red:', error)

        return Promise.reject('Error de red.')
      })
  },

  putDetalle: (
    idOperacion: number,
    idDetalle: number,
    detalle: OperacionNotaEstructuradaDetalleUpdate
  ): Promise<BaseResponse> => {
    const parsed = schemaOperacionNotaEstructuradaDetalleUpdate.safeParse(detalle)

    if (!parsed.success) {
      console.error('Error de validación:', parsed.error.issues)

      return Promise.reject(new Error('Error de validación.'))
    }

    return HttpAxiosRequest.put(getEndpoint(`/${idOperacion}/detalles/${idDetalle}`), parsed.data)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(error => {
        console.error('Error de red:', error)

        return Promise.reject('Error de red.')
      })
  },

  getCuentas: (idOperacion: number): Promise<CuentaNotaEstructurada[]> => {
    return HttpAxiosRequest.get(getEndpoint(`/${idOperacion}/cuentas`))
      .then(response => {
        const parsed = schemaCuentasNotaEstructurada.safeParse(response)

        if (!parsed.success) {
          console.error('Error de validación:', parsed.error.issues)

          return Promise.reject(new Error('Error de validación.'))
        }

        return parsed.data
      })
      .catch(error => {
        console.error('Error de red:', error)

        return Promise.reject('Error de red.')
      })
  },

  deleteCuenta: (idOperacion: number, idCuenta: number): Promise<BaseResponse> => {
    return HttpAxiosRequest.delete(getEndpoint(`/${idOperacion}/cuentas/${idCuenta}`))
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(error => {
        console.error('Error de red:', error)

        return Promise.reject('Error de red.')
      })
  },

  putCuentaDetalle: (
    idOperacion: number,
    idCuenta: number,
    idDetalle: number,
    detalle: OperacionNotaEstructuradaCuentaDetalleUpdate
  ): Promise<BaseResponse> => {
    const parsed = schemaOperacionNotaEstructuradaCuentaDetalleUpdate.safeParse(detalle)

    if (!parsed.success) {
      console.error('Error de validación:', parsed.error.issues)

      return Promise.reject(new Error('Error de validación.'))
    }

    return HttpAxiosRequest.put(
      getEndpoint(`/${idOperacion}/cuentas/${idCuenta}/detalles/${idDetalle}`),
      parsed.data
    )
      .then(res => Promise.resolve(res))
      .catch(err => Promise.reject(err))
  },

  descargarInforme: (idOperacion: number): Promise<any> =>
      HttpOperacionInforme.descargarInforme(idOperacion, SistemaTipo.NotaEstructurada),
} as const
